import React from 'react';
import { ThemedFunctor } from '@doveit/bricks';
import * as styles from './PageLayoutMain.style';

export interface PageLayoutMainProps {
  addCss?: ThemedFunctor,
  desktopOrder?: number,
  children: React.ReactNode,
}

// @TODO: Change root div with a more specific tag <main /> after the layout refactoring
const PageLayoutMain: React.FC<PageLayoutMainProps> = ({
  desktopOrder,
  children,
  addCss,
  ...rest
}) => (
  <div
    css={styles.main}
    $order={desktopOrder}
    $addCss={addCss}
    {...rest}
  >
    {children}
  </div>
);

export default PageLayoutMain;
